import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import RuleBoardImage from "../../../assets/intro/ruleboard.png";

import typography from "../../../theme/typography";

import TextButton from "../../shared/TextButton";

const Page = styled.div`
  position: relative;
  background-color: #1e1e1e;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.color.white};
`;

const RuleBoard = styled.div`
  position: relative;
  margin-top: 103px;
  margin-bottom: 41px;
  color: ${(props) => props.theme.color.black};
  ${typography.mainText1};
  height: 216px;
`;

const PlaceHolder = styled.div`
  width: 316px;
  height: 216px;
`;

const RuleText = styled.div`
  position: absolute;
  top: 67px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  p {
    margin-top: 14px;
  }
`;

const Text = styled.p`
  ${typography.mainText2};
  margin-bottom: 90px;
`;

const IntroPage4 = () => {
  const [loading, setLoading] = useState(true);

  return (
    <Page>
      <RuleBoard>
        {loading && <PlaceHolder />}
        <img
          src={RuleBoardImage}
          alt="규칙판"
          onLoad={() => setLoading(false)}
        />
        <RuleText>
          <span>규칙</span>
          <p>
            쓰레기를 20L 이상 만들면
            <br />
            내가 책임진다
          </p>
        </RuleText>
      </RuleBoard>

      <Text>
        서울시가 언제
        <br />
        대체매립지를 확보할지
        <br />
        모르는 상황 <br />
        <br />
        ‘쓰레기통 없이 살아보기’에
        <br />
        도전하시겠습니까?
      </Text>

      <Link to="/game">
        <TextButton text="네" />
      </Link>
    </Page>
  );
};

export default IntroPage4;
